import axios from 'axios'

const baseDomain = ''
const version = '1'
const namespace = `swisspass/v${version}`
const baseURL = `${baseDomain}/wp-json/${namespace}`

const Service = axios.create({
  baseURL,
})

export default {
  async getUserData($params) {
    const resp = await Service.get('/get_data', {
      params: $params,
    })
    const data = resp.data

    return data
  },
}
